// extracted by mini-css-extract-plugin
export default {"content":"ViewOnlyModal_content__ye99b","contentHeading":"ViewOnlyModal_contentHeading__CvZe7","modalButton":"ViewOnlyModal_modalButton__Lerd+"};